module.exports = __webpack_public_path__ + "ipetbooking/admin/img/user-clock.a2bbbc9b.svg";